import { Box } from "./box/Box"

export const Divider = () =>{
    return <Box sx={{
        background:"linear-gradient(0deg, rgba(255,255,255,0.05) 50%, rgba(0,0,0,.8) 50%)",
        height:"2px",
        maxHeight:"2px"
    }}></Box>
}